import LoadingState from './LoadingState';
import { AudioContextShape, AudioState } from './models/AudioContextShape';
import { createContext, useState } from 'react';

export const AudioContext = createContext<AudioContextShape>(null);

export default function AudioProvider({ children }) {
    const [audio, setAudio] = useState<AudioState>({ duration: 0, paused: true, pause: null, play: null, currentTime: 0, setCurrentTime: null, loading: false });
    
    return <AudioContext.Provider value={ { state: audio, setState: setAudio }}>
        <LoadingState show={audio.loading} />
        { children }
    </AudioContext.Provider>;
}